import React, { useState, useEffect } from "react";
import logo from "../../assets/img/logo.png";
import { notify } from "react-notify-toast";

import PasswordStrengthMeter from "../Register/PasswordStrengthMeter";
import FormField from "../../Components/FormField/FormField";
import PasswordToggle from "../../Components/FormField/PasswordToggle";
import ConfirmButton from "../../Components/Buttons/ConfirmButton";
import SignupContainer from "../Signup-Login/SignupContainer"
import { API } from "../../API";

// This page is opened when user opens the link reveived through email.
const ResetPassword = (props) => {
  const id = props.match.params.id;
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [checkPassword, setCheckPassword] = useState([]);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    const getUser = async () => {
      API.getEmailByToken(id)
        .then((res) => {
          setEmail(res.data.user.email);
        })
        .catch((err) => {
          console.log(err);
        });
    };
    getUser();
  }, []);

  /*const handleResetPassword = (event) => {
        event.preventDefault()
        console.log('Testing')
    }*/

  const togglePassword = () => {
    //Toggles between showing and hiding password
    setShowPassword(!showPassword);
  };

  const toggleConfirmPassword = () => {
    //Toggles between showing and hiding password
    setShowConfirmPassword(!showConfirmPassword);
  };

  const handleSubmit = (event) => {
    console.log(document.querySelector("progress").value);
    event.preventDefault();
    if (checkPassword.length == 0) {
      if (password === confirmPassword) {
        if (parseInt(document.querySelector("progress").value) >= 3) {
          setError(false);
          //console.log(email," ",password)
          API.resetPassword({
            user: {
              email: email,
              password: password,
              token: props.match.params.token,
              id: props.match.params.id,
            },
          })
            .then((res) => {
              console.log("data sent to backend");
             // console.log(res.data.type)
              props.history.push((res.data.type === 'teacher' ? '/login' : '/LoginAsInstitution'));
              notify.show("Your password is updated");
            })
            .catch((err) => {
              console.dir(err);
              if (err.response.data.errors) {
                console.dir(err);
                const errors = err.response.data.errors;
                console.log("error::::", errors.password);
                if (errors.password) {
                  notify.show(`Your password ${errors.password}`);
                  console.log("ResetPassword.js: ", errors.password);
                } else if (errors.email) {
                  notify.show(`Your email ${errors.email}`);
                  console.log("ResetPassword.js: ", errors.email);
                } else if (errors.token) {
                  notify.show(errors.token);
                  console.log("ResetPassword.js: ", errors.token);
                }
              } else {
                console.log("ResetPassword.js: ", err);
              }
            });
        } else {
          notify.show(
            "Please make your new password stronger. Try adding more characters, digits or special characters."
          );
        }
      } else {
        setError(true);
        notify.show("Passwords do not match.");
      }
    } else {
      notify.show("Check the required password condition.");
    }
  };

  const handlePassword = (e) => {
    let password = e.target.value;
    let passwordarray = [];
    if (!password.match(".{8,}")) passwordarray.push("8 characters");
    if (!password.match("(?=.*?[0-9])")) passwordarray.push("1 digit");
    setCheckPassword(passwordarray);
  };

  return (
    <SignupContainer
      heading="Reset Password"
      onSubmit={handleSubmit}
    >
      {/* <div className="row">
      <div className="col-lg-6 auth-left">
        <div className="row auth-form mb-4 login-form-container small-screen-reset-password-container">
          <div className="col-12 col-sm-12"> */}
      <div className="auth-text-top mb-4 text-center">
        <small>Enter your new password.</small>
      </div>
      <FormField
        label="Email"
        type="email"
        icon="email"
        placeholder={email}
        value={email}
        autoFocus
        required
        // this field must be disabled to avoid user's falsifying email
        disabled
      />
      <FormField
        label="Password"
        icon="lock"
        type={showPassword ? "text" : "password"}
        placeholder="Enter Your Password"
        value={password}
        onChange={(e) => (
          setPassword(e.target.value), handlePassword(e)
        )}
        required
        header={
          checkPassword.length > 0
            ? checkPassword.length > 1
              ? " must contain " +
              checkPassword[0] +
              " including " +
              checkPassword[1]
              : " must contain " + checkPassword[0]
            : null
        }
      >
        <PasswordToggle onClick={togglePassword} />
      </FormField>
      <PasswordStrengthMeter password={password} />
      <FormField
        label="Confirm Password"
        icon="lock"
        type={showConfirmPassword ? "text" : "password"}
        className={
          confirmPassword !== "" && confirmPassword !== password
            ? "error-form-control"
            : ""
        }
        placeholder="Repeat Your Password"
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
        required
      >
        <PasswordToggle onClick={toggleConfirmPassword} />
      </FormField>
      <ConfirmButton
        type="submit"
      >
        Reset Password
              </ConfirmButton>
      {/* </div>
        </div>
      </div> */}
      {/* <div className="col-lg-6 auth-right d-lg-flex d-none bg-photoregister">
        <div className="bg-gradient"></div>

        <div className="logo-container">
          <img src={logo} alt="logo" className="logo" />

          <div className="heading">
            <h2 className="name"> ReadyTeacher</h2>
            <p>
              Welcome to the ELICOS industry’s first and only staffing platform
            </p>
          </div>
        </div>

        <div className="shape"></div>
      </div> */}
      {/* </div> */}
    </SignupContainer>
  );
};

export default ResetPassword;
